module.exports = __webpack_public_path__ + "static/media/genesys-white.e8ac6ad9.png";